export default __webpack_public_path__ + "static/media/DP3 1A-2C-1EC V04.928352e6.jpg";